import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/style.css";
import "./styles/joinUsStyle.css";
import App from "./App";
import { routeFor } from "./routes";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import store from "./Components/app/store";

/* Scroll-reveal hides its targets only when JS is there to reveal them again.
 * Set before hydration so there is no flash of visible-then-hidden content —
 * and so a JS failure leaves the page readable rather than blank, which is
 * what an unconditional `[data-reveal] { opacity: 0 }` used to guarantee. */
document.documentElement.classList.add("js-reveal");

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

function mount() {
  /* The build is prerendered to static HTML (scripts/prerender.py), so on the
   * live site #root already contains markup — hydrate it instead of
   * re-rendering from scratch. Dev server / non-prerendered loads fall back to
   * createRoot. */
  if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, app, {
      /* The HTML being hydrated is a BROWSER's serialisation of a live DOM
       * (scripts/prerender.py), not React's own server output, so it carries
       * none of the markers React emits and expects to find.
       *
       * The causes are removed rather than swallowed: no Suspense boundary
       * anywhere in the tree (React hydrates one by looking for the `<!--$-->`
       * comments a browser DOM cannot have — see src/routes.js), the route's
       * chunk is resolved before hydration starts, every post-mount structural
       * upgrade is gated on useIsHydrated, and the prerender pass strips
       * runtime-only state from the snapshot. scripts/verify_ui.py asserts a
       * clean hydration on every route.
       *
       * Kept as a handler rather than left to the default reportError, which
       * surfaces any future regression as window.onerror noise in Lighthouse
       * instead of a console line. */
      onRecoverableError: (err) => {
        console.debug("hydration recovered:", err && err.message);
      },
    });
  } else {
    ReactDOM.createRoot(container).render(app);
  }
}

/* Resolve the current route's chunk BEFORE hydrating, so the Suspense boundary
 * has nothing to suspend on. Home is not split, so "/" mounts immediately. */
const route = routeFor(window.location.pathname);
if (route) route.preload().then(mount, mount);
else mount();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
